import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  PaymentSummary,
  PaymentTransactionsViewModel,
} from '@usf/payment-types';

@Injectable({
  providedIn: 'root',
})
export class PaymentsPaymentService {
  constructor(private translateService: TranslateService) {}

  createPaymentPostingDate(date: number): string {
    let postingDate = 'NA';
    const dateString = date?.toString();
    if (dateString != '0') {
      const year = dateString.slice(0, 4);
      const month = dateString.slice(4, 6);
      const day = dateString.slice(6, 8);
      postingDate = `${parseInt(month)}/${parseInt(day)}/${year}`;
    }
    return postingDate;
  }

  createPaymentSummary(
    paymentDate: string,
    customerAmount: number,
    transactions: PaymentTransactionsViewModel[],
  ): PaymentSummary {
    const statusText = transactions.length
      ? 'i18n.payments.paymentConfirmation.submitted'
      : 'i18n.payments.paymentConfirmation.notSubmitted';
    const totalAmount = transactions.reduce(
      (acc, transaction) => acc + (transaction.paymentAmount || 0),
      0,
    );

    return {
      paymentDate,
      status: this.translateService.instant(statusText),
      totalAmount,
      customerAmount,
      transactionAmount: transactions.length,
    };
  }
}
